"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _differenceInHours = _interopRequireDefault(require("date-fns/differenceInHours"));

var _Date = _interopRequireDefault(require("@airasia/phoenix-components/components/Date"));

var _Timer = _interopRequireDefault(require("@airasia/phoenix-components/components/Timer"));

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _cardTimer = require("./cardTimer.util");

var _cardTimer2 = _interopRequireDefault(require("./cardTimer.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var TimerContainer = _styledComponents.default.div.withConfig({
  displayName: "CardTimer__TimerContainer",
  componentId: "sc-6e87ab-0"
})(["display:flex;"]);

var LabelContainer = _styledComponents.default.span.withConfig({
  displayName: "CardTimer__LabelContainer",
  componentId: "sc-6e87ab-1"
})(["margin:0 ", " 0 ", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.micro;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.tiny;
});

var TimeContainer = _styledComponents.default.span.withConfig({
  displayName: "CardTimer__TimeContainer",
  componentId: "sc-6e87ab-2"
})([""]);

var CardTimer = function CardTimer(props) {
  var timerDetails = props.timerDetails,
      dateFormat = props.dateFormat,
      size = props.size,
      labelStartColor = props.labelStartColor,
      labelEndColor = props.labelEndColor,
      timeEndCallback = props.timeEndCallback,
      customProperties = props.customProperties,
      accessible = props.accessible,
      allowLocaleFormat = props.allowLocaleFormat,
      locale = props.locale,
      localeConfig = props.localeConfig,
      theme = props.theme;
  var timerLabelStartDays = timerDetails.timerLabelStartDays,
      timerLabelStartHours = timerDetails.timerLabelStartHours,
      timerLabelEndDays = timerDetails.timerLabelEndDays,
      timerLabelEndHours = timerDetails.timerLabelEndHours,
      timerTimeZone = timerDetails.timerTimeZone,
      timerStartDateTime = timerDetails.timerStartDateTime,
      timerEndDateTime = timerDetails.timerEndDateTime;
  var timeZone = timerTimeZone && timerTimeZone.length > 0 ? timerTimeZone : _constant.DEFAULT_TIMEZONE;
  var dateNow = (0, _cardTimer.convertDateToTimeZone)(new Date(), timeZone);
  var checkedTimerStartDateTime = (0, _cardTimer.checkDateTimeFormat)(timerStartDateTime);
  var checkedTimerEndDateTime = (0, _cardTimer.checkDateTimeFormat)(timerEndDateTime);
  var startDate = new Date(checkedTimerStartDateTime);
  var endDate = new Date(checkedTimerEndDateTime);

  var _useState = (0, _react.useState)(dateNow > startDate),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      started = _useState2[0],
      setStarted = _useState2[1];

  var _useState3 = (0, _react.useState)(dateNow > endDate),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      ended = _useState4[0],
      setEnded = _useState4[1];

  var dateToUse;
  var timerLabel;
  var textColor;
  var moreThanThreshold;
  var hoursDifferenceBeforeStart = (0, _differenceInHours.default)(startDate, dateNow);
  (0, _react.useEffect)(function () {
    if (ended && timeEndCallback) {
      timeEndCallback();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);

  if (!started) {
    moreThanThreshold = hoursDifferenceBeforeStart >= _constant.THRESHOLD_HOURS; // check if more than 24 hrs

    timerLabel = moreThanThreshold ? timerLabelStartDays : timerLabelStartHours;
    dateToUse = checkedTimerStartDateTime;
    textColor = labelStartColor;
  } else {
    var hoursDifferenceBeforeEnd = (0, _differenceInHours.default)(endDate, dateNow);
    moreThanThreshold = hoursDifferenceBeforeEnd >= _constant.THRESHOLD_HOURS;
    timerLabel = moreThanThreshold ? timerLabelEndDays : timerLabelEndHours;
    dateToUse = checkedTimerEndDateTime;
    textColor = labelEndColor;
  }

  var timerEndHandler = function timerEndHandler() {
    dateNow = (0, _cardTimer.convertDateToTimeZone)(new Date(), timeZone);
    setStarted(dateNow >= startDate);
    setEnded(dateNow > endDate);

    if (dateNow >= endDate && timeEndCallback) {
      timeEndCallback();
    }
  };

  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var getMain = function getMain() {
    if (ended) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }

    return /*#__PURE__*/_react.default.createElement(TimerContainer, (0, _extends2.default)({
      tabIndex: tabIndex
    }, customProperties), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: false,
      color: "greyDarker",
      fontsize: "titleSmall",
      icon: _constant.CARD_TIMER_ICON
    }), /*#__PURE__*/_react.default.createElement(LabelContainer, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      fontsize: size,
      color: textColor,
      accessible: false
    }, timerLabel)), /*#__PURE__*/_react.default.createElement(TimeContainer, null, moreThanThreshold ? /*#__PURE__*/_react.default.createElement(_Date.default, {
      size: size,
      color: textColor,
      accessible: false,
      date: new Date(dateToUse),
      format: dateFormat,
      allowLocaleFormat: allowLocaleFormat,
      locale: locale // eslint-disable-next-line react/prop-types
      ,
      localeConfig: localeConfig.date
    }) : /*#__PURE__*/_react.default.createElement(_Timer.default, {
      size: size,
      timeZone: timeZone,
      endDate: dateToUse,
      color: textColor,
      theme: theme,
      timeEndCallback: timerEndHandler,
      allowLocaleFormat: allowLocaleFormat,
      locale: locale // eslint-disable-next-line react/prop-types
      ,
      localeConfig: localeConfig.time
    })));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

CardTimer.propTypes = _cardTimer2.default.PropTypes;
CardTimer.defaultProps = _cardTimer2.default.DefaultProps;
var _default = CardTimer;
exports.default = _default;